<template>
	<div class="p-3">
		<div className='box p-5'>
			<div class='mb-2'>
				<div class="has-text-centered">
					<svg class="is-" width="56" height="46" viewBox="0 0 56 46" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M6.38617 21.281H4.88617H6.38617ZM6.38617 25.1142L5.39909 26.2437C5.96441 26.7378 6.80794 26.7378 7.37326 26.2437L6.38617 25.1142ZM11.7594 22.4104C12.3832 21.8653 12.447 20.9176 11.9018 20.2939C11.3567 19.6701 10.409 19.6063 9.78526 20.1515L11.7594 22.4104ZM2.98708 20.1515C2.3633 19.6063 1.4157 19.6701 0.870546 20.2939C0.325395 20.9177 0.389136 21.8653 1.01292 22.4104L2.98708 20.1515ZM45.8233 12.1729C46.2975 12.8522 47.2325 13.0186 47.9119 12.5444C48.5912 12.0703 48.7575 11.1352 48.2834 10.4559L45.8233 12.1729ZM28.317 0.614502C15.5727 0.614502 4.88617 9.68374 4.88617 21.281H7.88617C7.88617 11.7075 16.8372 3.6145 28.317 3.6145V0.614502ZM4.88617 21.281L4.88617 25.1142L7.88617 25.1142L7.88617 21.281H4.88617ZM7.37326 26.2437L11.7594 22.4104L9.78526 20.1515L5.39909 23.9848L7.37326 26.2437ZM7.37326 23.9848L2.98708 20.1515L1.01292 22.4104L5.39909 26.2437L7.37326 23.9848ZM48.2834 10.4559C44.1323 4.50824 36.7061 0.614502 28.317 0.614502V3.6145C35.7983 3.6145 42.2736 7.08694 45.8233 12.1729L48.2834 10.4559Z" fill="#71B6FF"/>
						<path d="M49.8196 20.5143L50.8046 19.383C50.2399 18.8914 49.3993 18.8914 48.8347 19.383L49.8196 20.5143ZM44.4317 23.2163C43.8069 23.7602 43.7414 24.7077 44.2854 25.3325C44.8293 25.9573 45.7768 26.0229 46.4016 25.4789L44.4317 23.2163ZM53.2376 25.4789C53.8624 26.0229 54.8099 25.9573 55.3539 25.3325C55.8978 24.7077 55.8323 23.7602 55.2075 23.2163L53.2376 25.4789ZM10.2254 33.4534C9.7501 32.775 8.81473 32.6103 8.13625 33.0856C7.45777 33.561 7.2931 34.4963 7.76845 35.1748L10.2254 33.4534ZM27.8049 45.014C40.5898 45.014 51.3196 35.9498 51.3196 24.3476H48.3196C48.3196 33.9161 39.3368 42.014 27.8049 42.014V45.014ZM51.3196 24.3476V20.5143H48.3196V24.3476H51.3196ZM48.8347 19.383L44.4317 23.2163L46.4016 25.4789L50.8046 21.6456L48.8347 19.383ZM48.8347 21.6456L53.2376 25.4789L55.2075 23.2163L50.8046 19.383L48.8347 21.6456ZM7.76845 35.1748C11.9353 41.1223 19.3879 45.014 27.8049 45.014V42.014C20.291 42.014 13.7888 38.5396 10.2254 33.4534L7.76845 35.1748Z" fill="#71B6FF"/>
					</svg>
				</div>
			</div>
			<p class="mb-5">
				An account with this email address already exists. By clicking "accept", I understand that I am updating the account to be a Lead Gen account. 
			</p>
			<div class="has-text-right">
				<button class="button is-danger" @click="close(null)">Cancel</button>
				<button class="button is-primary ml-2" @click="close(true)">Accept</button>
			</div>
		</div>
	</div>
</template>

<script lang="ts">
import { closeModal } from '@/utils/mixins';
import { defineComponent } from 'vue';

export default defineComponent({
	mixins: [closeModal]
})

</script>

<style scoped>
	
</style>
